// src/components/ui/Pill.tsx — small uppercase badge.
import type { CSSProperties, ReactNode } from "react";
import { C, F } from "../../theme";

export type PillTone = "brass" | "heather" | "sage" | "signal" | "paper" | "ink";

export interface PillProps {
  tone?: PillTone;
  small?: boolean;
  children: ReactNode;
  style?: CSSProperties;
}

const tones: Record<PillTone, { bg: string; fg: string; bd: string }> = {
  brass:   { bg: C.brassBg,   fg: C.brassDk,   bd: "rgba(167,117,28,0.20)" },
  heather: { bg: C.heatherBg, fg: C.heatherDk, bd: "rgba(122,93,140,0.22)" },
  sage:    { bg: C.sageBg,    fg: C.sageDk,    bd: "rgba(110,140,114,0.22)" },
  signal:  { bg: C.signalBg,  fg: C.signalDk,  bd: "rgba(184,58,43,0.22)" },
  paper:   { bg: C.paperWarm, fg: C.inkSoft,   bd: C.hairline },
  ink:     { bg: "#2B2014",   fg: C.brassGlow, bd: "transparent" },
};

export const Pill = ({ tone = "brass", small, children, style }: PillProps) => {
  const t = tones[tone];
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: small ? "3px 9px" : "5px 11px",
        borderRadius: 999,
        background: t.bg,
        color: t.fg,
        fontSize: small ? 11 : 12,
        fontWeight: 800,
        letterSpacing: 0.4,
        textTransform: "uppercase",
        border: `1px solid ${t.bd}`,
        fontFamily: F.body,
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {children}
    </span>
  );
};
